import {
  PLAYING_AUDIO_MESSAGE_HIGHLIGHT_CLASSNAME,
  SHARING_AUDIO_MESSAGE_HIGHLIGHT_CLASSNAME,
} from '@modules/feedback/components/AudioType/AudioTranscript/constants';
import { removeFeedbackMessageHighlight } from '@modules/feedback/components/AudioType/utils';

export const highlightSharingAudioTranscriptMessage = (
  msgIndices: number[],
) => {
  requestAnimationFrame(() => {
    removeFeedbackMessageHighlight(SHARING_AUDIO_MESSAGE_HIGHLIGHT_CLASSNAME);
    removeFeedbackMessageHighlight(PLAYING_AUDIO_MESSAGE_HIGHLIGHT_CLASSNAME);

    if (msgIndices.length === 0) {
      return;
    }

    const querySelectorAttributes = msgIndices
      .map((msgIndex) => `[data-audio-message-id="${msgIndex.toString()}"]`)
      .join(', ');

    const messagesToHighlight = document.querySelectorAll(
      `#expanded-feedback-container ${querySelectorAttributes}`,
    );

    messagesToHighlight.forEach((message) => {
      message.classList.add(SHARING_AUDIO_MESSAGE_HIGHLIGHT_CLASSNAME);
    });
  });
};
